import {
	DpCerrarSX,
	DpContentCardSX,
	DpImageSX,
	DpLinkSX,
} from '@/components/blocks/DpLibrary/DpFloatingCard/style';
import { useDpHidden } from '@/components/blocks/DpLibrary/DpHiddenForDay';
import { Img } from '@/components/blocks/MaterialImage';
import { combineSX } from '@/utils/combineSX';
import { Box, BoxProps, Link, SxProps } from '@mui/material';

type DpFloatingCardProps = BoxProps & {
	href?: string;
	img: string;
	alt?: string;
	xscard?: SxProps;
	example?: boolean;
};

export const DpFloatingCard = ({ href, img, alt, example }: DpFloatingCardProps) => {
	const { showComponent, hideComponent } = useDpHidden({
		id: 'banner-home',
		mode: 'day_show',
		autoHidden: false,
	});

	if (!showComponent) {
		return null;
	}

	const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		hideComponent();
	};

	return (
		<Box component="div" id="banner-home" sx={combineSX([DpContentCardSX(example ?? false)])}>
			<Link href={href ?? ''} sx={DpLinkSX}>
				<Img src={img} alt={alt ?? ''} sx={DpImageSX} id="banner-home-img" />
			</Link>
			<Box component="span" id="cerrar-banner-home" sx={DpCerrarSX} onClick={handleClose}>
				<Img
					alt="cerrar"
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/AuroraStorefrontAssetStore/images/jersey/cerrar.png"
				/>
			</Box>
		</Box>
	);
};
